import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { cartContainsAnyFreeTrialBundle } from '../lib/cart';
import { useCartMode } from '../lib/cartModes';
import * as types from '../types';

export default function useCartHasFreeTrialBundle(): boolean {
  const { cartSelector } = useCartMode();
  const cart = useSelector(cartSelector);
  const products = useSelector((state: types.AppState) => state.config.products);

  return useMemo(() => cartContainsAnyFreeTrialBundle(cart, products), [cart, products]);
}
